<template>
  <div class="content-container">
    <div class="top-control-container">
      <div style="font-weight: 600; display: grid; gap: 8px">
        <div v-if="action !== 'create'" style="font-size: large">
          {{ bookingId }}
        </div>
        <div>Tổng: {{ Intl.NumberFormat().format(Math.abs(total)) }}</div>
        <div>
          Số tiền đã đặt cọc:
          {{ Intl.NumberFormat().format(Math.abs(depositedMoney)) }}
        </div>
      </div>
      <div class="button-containers">
        <button
          v-if="action != 'view'"
          class="btn primary medium"
          @click="onClickSaveBooking"
        >
          Lưu
        </button>
        <button
          class="btn primary medium outline"
          @click="onOpenBookingDepositDialog"
        >
          Đặt cọc
        </button>
        <!-- <button class="btn primary medium outline">Routing</button> -->
        <button class="btn primary medium outline" @click="onNavigateBack()">
          Quay lại
        </button>
      </div>
    </div>
    <div>
      <Tab
        v-model="tabIndex"
        class="tabmenu-container-custom"
        :tab-list="tabList"
      />
    </div>
    <!-- RESERVATION TAB -->
    <template v-if="isHydrated">
      <div v-show="tabIndex === 1" class="tab-content">
        <BookingFormCustomerTab
          ref="BookingFormCustomerTab"
          :visible="tabIndex"
          :booking-travelers="formData.booking_traveller"
          @onAddCustomerToBooking="onAddCustomerToBooking"
          @onUpdateCustomer="onUpdateCustomer"
          @removeCustomerFromBooking="onRemoveCustomerFromBooking"
          @bookingMasterChanged="onBookingMasterChanged"
        ></BookingFormCustomerTab>
      </div>
      <div v-show="tabIndex === 2" class="tab-content">
        <BookingFormBookingTab
          ref="BookingFormBookingTab"
          :action="action"
          :booker="formData.booker"
          :booking-record="formData"
          @updateTotal="onUpdateTotal"
          @bookerSelected="onBookerSelected"
          @bookerRemoved="onBookerRemoved"
          @agencySelected="onAgencySelected"
          @vouchersApplied="onVouchersApplied"
          @voucherRemoved="onVoucherRemoved"
          @promotionSelected="onPromotionSelected"
        ></BookingFormBookingTab>
      </div>
      <!-- OTHER INFORMATION TAB -->
      <div v-show="tabIndex === 3" class="tab-content">
        <BookingFormAdditionalInfoTab
          ref="BookingFormAdditionalInfoTab"
          :additional-info-data="formData.additional_info"
          :booking-data="formData.vehicles"
          :agent-id="formData.additional_info.agent_id"
        ></BookingFormAdditionalInfoTab>
      </div>
      <el-dialog
        width="900px"
        :visible="isBookingDepositDialogOpened"
        title="Thêm đặt cọc cho đặt phòng"
        @close="onCloseBookingFormDepositDialog"
      >
        <div>
          <BookingFormDepositDialog
            ref="BookingFormDepositDialog"
            :booking-code="bookingId"
            :booking-id="masterBookingRoom?.id"
            :booker="formData.booker"
          ></BookingFormDepositDialog>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small"
              @click="onCloseBookingFormDepositDialog"
            >
              Đóng
            </button>
            <button class="btn primary small outline" @click="onCreateDeposit">
              Đặt cọc
            </button>
          </div>
        </div>
      </el-dialog>
    </template>
    <div v-else class="tab-content"></div>
  </div>
</template>

<script>
import bus from '@/utils/bus'
import Tab from '@/components/Tab'
import { createBookingDeposit } from '@/api/booking_service/deposit'
import BookingFormDepositDialog from './BookingFormDepositDialog.vue'
import BookingFormCustomerTab from './BookingFormCustomerTab.vue'
import BookingFormBookingTab from './BookingFormBookingTab.vue'
import BookingFormAdditionalInfoTab from './BookingFormAdditionalInfoTab.vue'
import {
  generateDailyPriceApi,
  getIdImageApi,
  // getIdImageApi,
  insertBookingApi,
  getBookingRoom,
  updateBookingRoom
} from '@/api/booking_service/booking'
import { getBooking, updateBooking } from '@/api/booking_service/bookingGroup'
import { getTravellerByIdApi } from '@/api/configuration/profile/traveller'
import { notifyError, notifySuccess } from '@/utils/toast'
import { getAllCurrencyApi } from '@/api/common/currency'
import { getBookingBalance } from '@/api/booking_service/booking-balance'
// eslint-disable-next-line no-unused-vars
import { Client } from '@stomp/stompjs'
// eslint-disable-next-line no-unused-vars
import { io } from 'socket.io-client'
import { getClientIpApi } from '@/api/auth_service/authManage'
import { BOOKING_FORM_CONST } from '@/constant'
// const fs = require('fs')

export default {
  components: {
    Tab,
    BookingFormBookingTab,
    BookingFormAdditionalInfoTab,
    BookingFormCustomerTab,
    BookingFormDepositDialog
  },
  props: {
    defaultRooms: {
      default: null
    },
    action: {
      required: true,
      default: 'create',
      validator: value => {
        return ['create', 'edit', 'view'].includes(value)
      }
    },
    bookingId: null
  },
  data() {
    return {
      clientIp: null,
      depositedMoney: null,
      isHydrated: false,
      isBookingRoomDialogOpened: false,
      isBookingDepositDialogOpened: false,
      bookingRoomFormData: null,
      bookingRoomTableIndex: null,
      bookingRoomFormAction: 'create',
      formData: {
        booker: {
          id: null,
          name: 'Mr',
          phone: '',
          email: null,
          first_name: null,
          last_name: null
        },
        release_date: null,
        additional_info: {
          note: null,
          agent_id: null,
          sales_person_id: null,
          debit_account_id: null,
          market_seg_id: null,
          source_id: null,
          pay_method: null,
          commission_fee: null,
          commission_percent: null,
          credit_card: null,
          credit_card_owner: null,
          expired_credit_card: null,
          room_booking_code: null,
          invoice_agent_name: null,
          invoice_address: null,
          invoice_name: null,
          invoice_tax: null,
          invoice_phone: null,
          invoice_email: null,
          special_command: null,
          e_invoice: false,
          promotion_id: null,

          group_code: null,
          booking_status: 1
        },
        booking_traveller: [],
        booking_room: [],
        deposit: null,
        vehicles: [],
        voucher_list: [],
        promotion_id: null
      },
      tabIndex: 2,
      tabList: [
        { label: 'Khách', value: 1 },
        { label: 'Đặt phòng', value: 2 },
        { label: 'Thông tin khác', value: 3 }
      ],
      titleOptions: [
        { label: 'Mr', value: 'Mr' },
        { label: 'Mrs', value: 'Mrs' },
        { label: 'Ms', value: 'Ms' }
      ],
      total: 0,
      socketClient: null,
      customerFormCard: {
        first_name: null,
        last_name: null,
        sex: null,
        birth: null,
        id_card: null,
        address_1: null,
        address_2: null,
        nationality_id: 380
      },
      customerImagesCard: {}
    }
  },
  computed: {
    masterBookingRoom() {
      return this.formData.booking_room.find(
        booking_room => booking_room.is_master
      )
    }
  },
  watch: {
    tabIndex(val) {
      if (this.tabIndex === 1) {
        this.initSocket()
      } else {
        this.closeSocket()
      }
    }
  },
  async created() {
    this.isHydrated = false
    if (this.bookingId != null) {
      await this.getBooking(this.bookingId)
      await getBookingBalance(this.bookingId)
        .then(res => {
          this.depositedMoney = res?.data ?? 0
        })
        .catch(err => {
          const message = err?.response?.data?.message
          this.$message({
            type: 'error',
            message: message ?? 'Đã có lỗi xảy ra khi lấy thông tin đặt cọc'
          })
        })
    } else {
      console.log('AVADA KEDAVRA')
      if (this.defaultRooms) {
        console.log(this.defaultRooms)
        const defaultCurrency = await getAllCurrencyApi().then(response => {
          return response.data[0]
        })
        this.defaultRooms.forEach(async (roomBooking, index) => {
          const is_master = index === 0
          roomBooking.days.forEach(async (day, dayIndex) => {
            const record = {
              is_master: is_master && dayIndex === 0,
              num_of_night: this.$moment(day.end).diff(
                this.$moment(day.start),
                'days'
              ),
              is_bf: false,
              num_of_guest: roomBooking.room?.people_num ?? 1,
              currency_id: defaultCurrency?.id,
              currency_code: defaultCurrency?.code,
              room_num: roomBooking.room.room_num,
              room_id: parseInt(roomBooking.room.room_id),
              room_type_name: roomBooking.room.room_level_code,
              hotel_id: parseInt(roomBooking.room.hotel_id),
              room_type_id: parseInt(roomBooking.room.room_level_id),
              arrive_date: day.start + ' 14:00',
              depart_date: day.end + ' 12:00'
            }

            await generateDailyPriceApi(
              record.arrive_date,
              record.depart_date,
              record.room_type_id,
              record.is_bf
            )
              .then(res => {
                record.daily_price = res.data.map(day => {
                  return {
                    id: 0,
                    price: day.price,
                    date: day.date,
                    note: null,
                    price_code_id: day.price_code_id,
                    price_code: day.price_code,
                    nett: day.nett,
                    currency_id: day.currency_id,
                    currency_code: day.currency_code,
                    exchange_rate: day.exchange_rate,
                    percent_discount: day.percent_discount,
                    amount_discount: day.amount_discount,
                    discount_reason: day.discount_reason
                  }
                })
              })
              .catch(err => {
                // throw err
                console.log(err)
              })
            console.log('YOU MUGGLE!!!!')
            this.formData.booking_room.push(record)
          })
        })
      }
    }
    this.isHydrated = true
    await this.getClientIp()
  },
  beforeDestroy() {
    this.closeSocket()
  },
  methods: {
    async getClientIp() {
      const res = await getClientIpApi()
      this.clientIp = res?.data?.[0]
    },
    onUpdateTotal(value) {
      // console.debug('onUpdateTotal', value)
      this.total = value
    },
    onSelectDuplicateCustomer() {},
    onAgencySelected(id) {
      this.formData.additional_info.agent_id = id
    },
    onVouchersApplied(voucherCodes) {
      // Cập nhật voucher_list với danh sách voucher đã được áp dụng thành công
      this.formData.voucher_list = voucherCodes
    },
    onVoucherRemoved(voucherCode) {
      this.formData.voucher_list = this.formData.voucher_list.filter(voucher => voucherCode.code !== voucher)
    },
    onOpenBookingDepositDialog() {
      this.isBookingDepositDialogOpened = true
      this.$nextTick(() => {
        this.$refs.BookingFormDepositDialog.hydrateForm()
      })
    },
    onPromotionSelected(promotionId) {
      if (promotionId === null || promotionId === '') {
        this.formData.promotion_id = null
        return
      }
      this.formData.promotion_id = promotionId
    },
    onOpenUpdateBookingRoom() {
      this.bookingRoomFormAction = 'edit'
      this.isBookingRoomDialogOpened = true
    },
    onOpenCreateBookingRoom() {
      this.bookingRoomFormData = null
      this.bookingRoomTableIndex = null
      this.bookingRoomFormAction = 'create'
      this.isBookingRoomDialogOpened = true
    },

    validateBookingRooms() {
      const bookingRoomByRoomType = {}
      this.formData.booking_room.forEach(bookingRoom => {
        // Bỏ qua các phòng đã hủy (status = 3) khi kiểm tra trùng
        if (bookingRoom.status === 3) {
          return
        }
        if (!bookingRoom.room_id) {
          return
        }
        if (!bookingRoomByRoomType[bookingRoom.room_id]) {
          bookingRoomByRoomType[bookingRoom.room_id] = [bookingRoom]
        } else {
          bookingRoomByRoomType[bookingRoom.room_id].push(bookingRoom)
        }
      })

      function areRoomBookingOverlap(A, B) {
        if (B.arrive_date < A.arrive_date) {
          return B.depart_date > A.arrive_date
        } else {
          return B.arrive_date < A.depart_date
        }
      }
      const bookingsByType = Object.values(bookingRoomByRoomType)

      for (
        let bookingTypeIdx = 0;
        bookingTypeIdx < bookingsByType.length;
        bookingTypeIdx++
      ) {
        const bookings = bookingsByType[bookingTypeIdx]
        if (bookings.length < 2) {
          continue
        }
        for (let i = 0; i < bookings.length; i++) {
          const booking = bookings[i]
          for (let ii = 0; ii < bookings.length; ii++) {
            if (i === ii) {
              continue
            }
            if (areRoomBookingOverlap(booking, bookings[ii])) {
              return booking.room_num // Early return if overlap
            }
          }
        }
      }
      return null
    },
    onClickSaveBooking() {
      let error = null
      error = this.$refs.BookingFormBookingTab.validateAdditionalInfoForm()
      error = this.$refs.BookingFormBookingTab.validateBookerFormData()
      error = this.$refs.BookingFormAdditionalInfoTab.validateVehicleFormData()

      if (error) {
        notifyError(error, true)
        return
      }

      const additionalInfoTabBookingInfo =
        this.$refs.BookingFormAdditionalInfoTab.dehydrateBookingFrom()
      const additionalInfo =
        this.$refs.BookingFormAdditionalInfoTab.dehydrateForm()
      const bookingAdditionalInfo =
        this.$refs.BookingFormBookingTab.dehydrateAdditionalInfoForm()
      const bookingForm = this.$refs.BookingFormBookingTab.dehydrateFormData()
      Object.assign(this.formData, bookingForm)
      Object.assign(this.formData, additionalInfoTabBookingInfo)
      Object.assign(this.formData.additional_info, additionalInfo)
      Object.assign(this.formData.additional_info, bookingAdditionalInfo)

      const hasOverlapRoom = this.validateBookingRooms()
      if (hasOverlapRoom) {
        notifyError(
          `Phòng ${hasOverlapRoom} đã được chọn trước đó. Vui lòng chọn phòng khác.`,
          true
        )
        return
      }
      if (this.bookingId) {
        this.updateBooking()
      } else {
        this.createBooking()
      }
    },
    async updateBooking() {
      bus.$emit('startLoader', { msg: '' })

      this.formData.booking_room.map(async room => {
        // Skip canceled rooms (status: 3 = CANCELED) - cannot update canceled rooms
        if (room.id && room.status !== 3) {
          if (
            !(await this.updateBookingRoom(room.id, room))
          ) {
            return
          }
        }
      })

      const payload = {}
      Object.assign(payload, this.formData)
      payload.booking_room = payload.booking_room.filter(
        item => item.id == null
      )
      await updateBooking(this.bookingId, payload)
        .then(response => {
          notifySuccess(response?.message)
        })
        .then(() => {
          this.$router.push('/reservation/search_reservation')
        })
        .catch(error => {
          notifyError(error?.response?.data?.message)
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    async createBooking() {
      bus.$emit('startLoader', { msg: '' })
      console.log('aaaa', this.formData)
      await insertBookingApi(this.formData)
        .then(response => {
          notifySuccess(response?.message)
        })
        .then(() => {
          this.$router.push('/reservation/search_reservation')
        })
        .catch(error => {
          notifyError(error?.response?.data?.message)
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    onUpdateCustomer(updatedCustomer) {
      this.formData.booking_traveller.find(customer => {
        if (customer.traveller_id === updatedCustomer.traveller_id) {
          console.debug('updatedCustomer', updatedCustomer)
          Object.assign(customer, updatedCustomer)
          this.refreshBookingTravellerTable()
          return true
        }
      })
    },
    onBookerRemoved(booker) {
      const masterTraveller = this.formData.booking_traveller.find(
        traveller => traveller.traveller_id === booker.id
      )
      if (masterTraveller != null) {
        masterTraveller.is_master = false
      }
      this.formData.booker.id = null
      this.formData.booker.last_name = null
      this.formData.booker.first_name = null
      this.formData.booker.phone = null
      this.formData.booker.email = null
      this.$refs.BookingFormBookingTab.hydrateBookerFormData(this.formData)
      this.refreshBookingTravellerTable()
    },
    onBookerSelected(booker) {
      this.formData.booking_traveller.forEach(traveller => {
        if (traveller.traveller_id === booker.id) {
          traveller.is_master = true
        } else {
          traveller.is_master = false
        }
      })
      this.formData.booker.id = booker.id
      this.formData.booker.last_name = booker.last_name
      this.formData.booker.first_name = booker.first_name
      this.formData.booker.phone = booker.phone
      this.formData.booker.email = booker.email
      this.refreshBookingTravellerTable()
    },
    onCloseBookingFormDepositDialog() {
      this.$refs.BookingFormDepositDialog.hydrateForm()
      this.isBookingDepositDialogOpened = false
    },
    async onCreateDeposit() {
      const error = this.$refs.BookingFormDepositDialog.validateFormData()
      if (error) {
        notifyError(error, true)
        return
      }
      // TODO: Extract submit logic from this form
      const payload = await this.$refs.BookingFormDepositDialog.dehydrateForm()
      if (this.bookingId != null) {
        await createBookingDeposit(payload)
          .then(res => {
            this.$message({
              type: 'success',
              message: 'Đã đặt cọc thành công'
            })
          })
          .catch(err => {
            const message = err?.response?.data?.message
            this.$message({
              type: 'error',
              message: message ?? 'Đã có lỗi xảy ra'
            })
          })

        await getBookingBalance(this.bookingId)
          .then(res => {
            this.depositedMoney = res?.data ?? 0
          })
          .catch(err => {
            const message = err?.response?.data?.message
            this.$message({
              type: 'error',
              message: message ?? 'Đã có lỗi xảy ra'
            })
          })
      } else {
        // Submit deposit along with payload when create new booking
        this.formData.deposit = payload
        this.depositedMoney = payload.deposit_money
        this.$message({
          type: 'success',
          message: 'Đã thêm đặt cọc'
        })
      }
      this.$refs.BookingFormDepositDialog.hydrateForm()
      this.isBookingDepositDialogOpened = false
    },
    async updateBookingRoom(id, payload) {
      await updateBookingRoom(id, payload)
        .then(res => {
          notifySuccess(res?.message)
          return true
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return false
        })
    },
    onRemoveCustomerFromBooking(customerId) {
      const travellerIndex = this.formData.booking_traveller.findIndex(
        traveller =>
          traveller.id === customerId || traveller.traveller_id === customerId
      )
      if (travellerIndex !== -1) {
        this.formData.booking_traveller.splice(travellerIndex, 1)
      }
    },
    onAddCustomerToBooking(customer) {
      const existingCustomer = this.formData.booking_traveller.find(
        bookingCustomer => bookingCustomer.traveller_id === customer.id
      )
      if (existingCustomer) {
        this.$message({
          type: 'error',
          message: 'Khách hàng đã nằm trong danh sách'
        })
        return
      }

      this.formData.booking_traveller.push({
        traveller_id: customer.id,
        first_name: customer.first_name,
        last_name: customer.last_name,
        phone: customer.phone_number,
        is_master: false,
        note: customer.note
      })

      this.$refs.BookingFormCustomerTab.hydrateCustomerForm()
    },
    async onBookingMasterChanged(colName, params, value) {
      const changedIndex = params.rowIndex
      this.formData.booking_traveller.forEach((traveller, index) => {
        if (index === changedIndex) {
          traveller.is_master = value
        } else {
          traveller.is_master = false
        }
      })

      if (value === true) {
        await this.updateBooker(params.data.traveller_id)
      } else {
        this.onBookerRemoved(params.data)
      }

      this.refreshBookingTravellerTable()
    },
    refreshBookingTravellerTable() {
      this.$refs.BookingFormCustomerTab.$refs.agGrid.gridOptions.api.refreshCells(
        {
          force: true
        }
      )
    },
    dehydrateDepositForm() {
      const payload = {
        booking_traveller: []
      }

      const booking_traveller = []
      booking_traveller.push({
        note: null,
        traveller_id: this,
        is_master: true
      })
      payload.booking_traveller = booking_traveller
    },
    async updateBooker(customerId) {
      const customer = await this.getCustomer(customerId)
      this.formData.booker.id = customer.id
      this.formData.booker.name = customer.name
      this.formData.booker.first_name = customer.first_name
      this.formData.booker.last_name = customer.last_name
      this.formData.booker.email = customer.email
      this.formData.booker.phone = customer.phone_number
    },
    async getCustomer(customerId) {
      const traveller = await getTravellerByIdApi({
        id: customerId
      })
        .then(response => {
          notifySuccess(response?.message)
          return response.data
        })
        .catch(err => {
          notifyError(err.response?.data?.message)
          return null
        })
      return traveller
    },
    dehydrateTab() {},
    dehydrateCustomerTab() {},
    dehydrateBookingTab() {},
    dehydrateAdditionalInfoTab() {},
    onNavigateBack() {
      this.$router.push('/reservation/search_reservation')
    },
    hydrateTab(index) {
      if (this.tabIndex === 1) {
        this.hydrateAdditionalInfoTab()
      } else if (this.tabIndex === 2) {
        this.hydrateBookingTab()
      } else if (this.tabIndex === 3) {
        this.hydrateCustomerTab()
      }
    },
    hydrateAdditionalInfoTab() {},
    hydrateBookingTab() {},
    hydrateCustomerTab(customer = null, uploadDocument = null, type = null) {
      this.$refs.BookingFormCustomerTab.hydrateCustomerForm(
        customer,
        uploadDocument,
        type
      )
    },
    async getBooking(bookingId) {
      const booking = await getBooking(bookingId)
        .then(res => {
          res.data.booking_room.forEach(roomBooking => {
            roomBooking.room = {
              room_num: roomBooking.room_num
            }
            roomBooking.room_type = {
              // TODO: Change this to room_type_name
              room_type_name: roomBooking.room_type_name
            }
          })
          return res.data
        })
        .catch(err => {
          const message = err?.response?.data?.message ?? 'errorMsg.default'
          this.$message({
            type: 'error',
            message: message
          })
        })
      // Lấy chi tiết cho tất cả các booking room
      const roomDetailPromises = booking.booking_room.map(room => getBookingRoom(room.id))
      const roomDetailResponses = await Promise.all(roomDetailPromises)
      booking.booking_room = roomDetailResponses.map(response => response.data)

      booking.additional_info.promotion_id = booking?.promotion_id
      this.formData = JSON.parse(JSON.stringify(booking))

      this.total = booking?.amount
    },

    // Socket - use for scanning ID Card (in tab 1)
    async initSocket() {
      const CHANNEL = '/topic/identification'
      this.socketClient = new Client({
        brokerURL: process.env.VUE_APP_SOCKET_HOST,
        onConnect: () => {
          this.socketClient.subscribe(CHANNEL, async message => {
            const content = JSON.parse(message.body).content
            const contentJSON = JSON.parse(content)
            this.onReceiveIdCardInfo(contentJSON)
          })
        }
      })
      this.socketClient.activate()
      // this.onReceiveIdCardInfo()

      // this.socketClient = io(process.env.VUE_APP_SWIPE_ID_CARD_SOCKET_HOST, {
      //   secure: true
      // })

      // this.socketClient.on('connect', () => {
      //   console.debug('CONNECTED')
      // })

      // this.socketClient.on('/event', data => {
      //   console.debug('[On event]', data)
      //   this.onReceiveIdCardInfo(data)
      // })
    },
    closeSocket() {
      // if (this.socketClient) {
      //   this.socketClient.disconnect()
      // }

      // Stomp
      if (this.socketClient) {
        this.socketClient?.deactivate()
      }
    },
    async onReceiveIdCardInfo(data) {
      // const id = data?.id
      // const msgData = data?.data
      // if (!msgData) return
      // if (id === 1) {
      //   // Case 1: New card
      //   // Refresh
      //   this.hydrateCustomerTab()
      //   this.handleRefreshCardData()
      // } else if (id === 2) {
      //   // Case 2: Receive data info
      //   this.onReceiveCustomerCardInfo(msgData)
      // } else if (id === 3) {
      //   // Case 3: Scan failed
      //   this.hydrateCustomerTab()
      //   this.handleRefreshCardData()
      // } else if (id === 4) {
      //   // Case 4: Receive img
      //   this.onReceiveCustomerCardImage(msgData)
      // }

      // const mockData = {
      //   personalIdentification: 'Nốtruồicách0.3cmtrướcđầumắtphải',
      //   wifeName: '',
      //   fatherName: 'VũVănQuảng',
      //   oldIdCode: '',
      //   gender: 'Nam',
      //   race: 'Kinh',
      //   originPlace: 'HùngThắng,TiênLãng,HảiPhòng',
      //   idCode: '031099002086',
      //   motherName: 'HoàngThịNgọc',
      //   dateOfBirth: '11/02/1999',
      //   religion: 'Không',
      //   personName: 'Vũ Đức Trường',
      //   expiryDate: '11/02/2024',
      //   nationality: 'ViệtNam',
      //   residencePlace: 'Khu4,ThịtrấnTiênLãng,TiênLãng,HảiPhòng',
      //   issueDate: '11/08/2021'
      // }
      if (!data) return
      const receiveIp = data?.ip?.[0]
      if (!this.clientIp || this.clientIp !== receiveIp) return

      const tmpNameParts = data.personName.split(' ')
      const firstName = tmpNameParts.pop()
      const lastName = tmpNameParts.join(' ')

      const res = await getIdImageApi({
        certificationNumber: data.idCode
      })
      const customerForm = {
        first_name: firstName,
        last_name: lastName,
        sex: data.gender === 'Nam' ? 1 : 2,
        birth: this.$moment(data.dateOfBirth, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        ),
        id_card: data.idCode,
        address_1: data.originPlace,
        address_2: data.residencePlace,
        nationality_id: 380
      }
      this.hydrateCustomerTab(
        customerForm,
        {
          uploadedDocumentsFront: {
            url: 'data:image/png;base64,' + res.data
          }
        },
        BOOKING_FORM_CONST.HYDRATE_CUSTOMER_FORM_TYPE.SWIPE_ID_CARD
      )
    },
    onReceiveCustomerCardInfo(data) {
      const tmpNameParts = data.personName.split(' ')
      const firstName = tmpNameParts.pop()
      const lastName = tmpNameParts.join(' ')

      this.customerFormCard = {
        first_name: firstName,
        last_name: lastName,
        sex: data.gender === 'Nam' ? 1 : 2,
        birth: this.$moment(data.dateOfBirth, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        ),
        id_card: data.idCode,
        address_1: data.originPlace,
        address_2: data.residencePlace,
        nationality_id: 380
      }

      this.hydrateCustomerTab(this.customerFormCard)
    },
    onReceiveCustomerCardImage(data) {
      if (data?.img_data) {
        this.customerImagesCard = {
          uploadedDocumentsFront: {
            url: 'data:image/png;base64,' + data.img_data
          }
        }
        this.hydrateCustomerTab(this.customerFormCard, this.customerImagesCard)
      }
    },
    handleRefreshCardData() {
      this.customerFormCard = {
        first_name: null,
        last_name: null,
        sex: null,
        birth: null,
        id_card: null,
        address_1: null,
        address_2: null,
        nationality_id: 380
      }
      this.customerImagesCard = {}
    }
  }
}
</script>
<style scoped>
.content-container .top-control-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
